import React, { useContext, useEffect, useState } from "react";

import { Table, Tooltip, Select } from "antd";
import { Context } from '../../context';
import "./index.css"

const { Column } = Table;
const { Option } = Select;

// Trending Titles and Views Component
export const TrendingTitlesTable = (props) => {
    const [loading, setLoading] = useState(false);
    const { token, apiUrl } = useContext(Context);
    const [error, setError] = useState(false);
    const [granularity, setGranularity] = useState();
    const [title, setTitle] = useState();
    const [data, setData] = useState([]);

    useEffect(() => {
        setGranularity(props?.granularity);
        setTitle(props?.title);
        const fetchData = async () => {
            setLoading(true);
            try {

                const headers = {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json',
                };

                const response = await fetch(`${apiUrl}/metrics/trending-titles`, {headers});
                const result = await response.json();
                setData(result?.trending_titles || []);
            } catch (err) {
                setError(true);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        setGranularity(props?.granularity);
        setTitle(props?.title);

        if (props?.granularity !== granularity || props?.title !== title) {
            const fetchData = async () => {
                setLoading(true);
                const headers = {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json',
                };

                try {
                    const response = await fetch(`${apiUrl}/metrics/trending-titles`, {headers});
                    const result = await response.json();
                    setData(result?.trending_titles || []);
                } catch (err) {
                    setError(true);
                } finally {
                    setLoading(false);
                }
            };
            fetchData();
        }
    }, [props]);

    const handleOnClick = (record) => {
        props.getGraphType(record?.title)
    }

    if (error) return <div>{error}</div>;

    return (
        <div className="table-wrapper" >
            <div className="table-heading">TRENDING TITLES  (Last 24 Hours)</div>
            <Table
                dataSource={data}
                size="small"
                loading={loading}
                pagination={{
                    style: {
                        background: "#fff",
                        marginTop: "0px",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "center",
                        paddingTop: "20px",
                        paddingBottom: "20px",
                    },
                }}
                style={{height: "350px"}}
                className="data-table-overview"
                locale={{
                    emptyText:
                        error || data?.length === 0 ? (
                            <div style={{ textAlign: "center", padding: "20px 0" }}>
                                No data found
                            </div>
                        ) : (
                            "No data available"
                        ),
                }}
                bordered={false}
                scroll={{ y: 300 }}
            >
                <Column
                    title="Trending Titles"
                    dataIndex="title"
                    key="title"
                    align="left"
                    render={(_, record) =>
                        record.value?.length > 50 ? (
                            <Tooltip title={record.value}>
                                <span>{`${record.value.slice(0, 50)}...`}</span>
                            </Tooltip>
                        ) : (
                            <span className="each-title" onClick={() => handleOnClick(record)}>{record?.title}</span>
                        )
                    }
                />
                <Column
                    title="Views & Score"
                    key="views_and_score"
                    align="right"
                    render={(_, record) => (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "right" }}>
                            <span style={{ fontWeight: "bold" }}>{`${record?.today_views || 0}`}</span>
                            <span style={{ color: `${record?.trending_score >= 0 ? "green" : "red"}` }}>{`${Math?.round(record?.trending_score)+ "%" || 0}`}</span>
                        </div>
                    )}
                />
            </Table>

        </div>
    );
};

// Top Titles and Views Component
export const TopTitlesTable = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const { token, apiUrl } = useContext(Context);
    const [granularity, setGranularity] = useState();
    const [title, setTitle] = useState();

    useEffect(() => {
        setGranularity(props?.granularity);
        setTitle(props?.title);
        const fetchData = async () => {
            setLoading(true);

            const headers = {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',
            }

            try {
                const response = await fetch(`${apiUrl}/metrics/top-titles?timeframe=${props.granularity ?? "60:min"}`, {headers});
                const result = await response.json();
                setData(result?.data || []);
            } catch (err) {
                setError(true);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        setGranularity(props?.granularity);
        setTitle(props?.title);

        if (props?.granularity !== granularity || props?.title !== title) {
            const fetchData = async () => {

                const headers = {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
    
                setLoading(true);
                try {
                    const response = await fetch(`${apiUrl}/metrics/top-titles?timeframe=${props.granularity ?? "60:min"}`, {headers});
                    const result = await response.json();
                    setData(result?.data || []);
                } catch (err) {
                    setError(true);
                } finally {
                    setLoading(false);
                }
            };
            fetchData();
        }
    }, [props]);

    const handleOnClick = (record) => {
        props.getGraphType(record?.value)
    }

    if (error) return <div>{error}</div>;

    return (
        <div className="table-wrapper">
            <div className="table-heading">Top Titles and Views</div>
            <Table
                dataSource={data}
                size="small"
                loading={loading}
                pagination={{
                    style: {
                        background: "#fff",
                        marginTop: "0px",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "center",
                        paddingTop: "20px",
                        paddingBottom: "20px"
                    },
                }}
                style= {{ height: "350px"}}
                className="data-table-overview"
                locale={{
                    emptyText: error || data?.length === 0 ? <div style={{ textAlign: "center", padding: "20px 0" }}>No data found</div>
                        : "No data available",
                }}
                bordered={false}
                scroll={{ y: 300 }}
            >
                <Column
                    title="Content Title"
                    dataIndex="value"
                    key="value"
                    align="left"
                    render={(_, record) =>
                        record.value?.length > 50 ? (
                            <Tooltip title={record.value}>
                                <span>{`${record.value.slice(0, 50)}...`}</span>
                            </Tooltip>
                        ) : (
                            <span onClick={() => handleOnClick(record)} className="each-title">
                                {record?.value}
                            </span>
                        )
                    }
                />
                <Column
                    title="Views"
                    dataIndex="total_count"
                    key="total_count"
                    align="center"
                    render={(value) => value || 0}
                />
            </Table>
        </div>
    );
};

// Views Seelction Wise
export const DistributionViews = (props) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("viewer_device_category");
    const { token, apiUrl } = useContext(Context);
    const [granularity, setGranularity] = useState();
    const [title, setTitle] = useState();

    const calculatePlayingTime = (totalPlayingTime) => {
        const totalPlayingTimeInSeconds = totalPlayingTime / 1000; // Convert ms to seconds
        const totalPlayingTimeInMinutes = totalPlayingTimeInSeconds / 60; // Convert seconds to minutes
        const totalPlayingTimeInHours = totalPlayingTimeInMinutes / 60; // Convert minutes to hours

        if (totalPlayingTimeInSeconds < 60) {
            return `${totalPlayingTimeInSeconds.toFixed(0)} sec`; // Less than 1 minute, show in seconds
        } else if (totalPlayingTimeInMinutes < 60) {
            return `${totalPlayingTimeInMinutes.toFixed(2)} min`; // Less than 1 hour, show in minutes
        } else {
            return `${totalPlayingTimeInHours.toFixed(2)} hrs`; // 1 hour or more, show in hours
        }
    }

    useEffect(() => {
        setGranularity(props?.granularity);
        setTitle(props?.title);
        const fetchData = async () => {
            setLoading(true);
            try {

                const url = props?.graphType === "views" ? `${apiUrl}/metrics/views/breakdown?timeframe=${props.granularity ?? "60:min"}&group_by=${selectedCategory}` : 
                
                `${apiUrl}/metrics/title/${props?.title}/views/breakdown?timeframe=${props.granularity ?? "60:min"}&group_by=${selectedCategory}`;

                const headers = {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
                const response = await fetch(`${url}`, {headers});

                const result = await response.json();
                setData(result?.data || []);
            } catch (err) {
                setError(true);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        setGranularity(props?.granularity);
        setTitle(props?.title);

        if (props?.granularity !== granularity || props?.title !== title || selectedCategory) {
            const fetchData = async () => {
                setLoading(true);
                try {
                    const url = props?.graphType === "views" ? `${apiUrl}/metrics/views/breakdown?timeframe=${props.granularity ?? "60:min"}&group_by=${selectedCategory}` : `${apiUrl}/metrics/title/${props?.title}/views/breakdown?timeframe=${props.granularity ?? "60:min"}&group_by=${selectedCategory}`;
                    const headers = {
                        "Authorization": `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                    const response = await fetch(`${url}`,{headers})
                    const result = await response.json();
                    setData(result?.data || []);
                } catch (err) {
                    setError(true);
                } finally {
                    setLoading(false);
                }
            };
            fetchData();
        }
    }, [selectedCategory, props]);

    if (error) return <div>{error}</div>;

    // Handle dropdown change
    const handleCategoryChange = (value) => {
        setSelectedCategory(value);
    };

    return (
        <div className="table-wrapper">
            <div className="table-heading">Views Breakdown By Distribution</div>
            <Table dataSource={data} size="small"
                pagination={{
                    style: {
                        background: "#fff",
                        marginTop: "0px",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "center",
                        paddingTop: "20px",
                        paddingBottom: "20px",
                        height: "350px"
                    },
                }}
                className="data-table-overview"
                locale={{
                    emptyText: error || data?.length === 0 ? <div style={{ textAlign: "center", padding: "20px 0" }}>No data found</div>
                        : "No data available",
                }}
                bordered={false}
                loading={loading}
                scroll={{ y: 300 }}
            >
                <Column
                    title={
                        <Select
                            value={selectedCategory}
                            onChange={handleCategoryChange}
                            style={{ width: 150, backgroundColor: "#ffff" }}

                        >
                            <Option value="viewer_device_category" style={{ backgroundColor: "#ffff" }}>Devices</Option>
                            <Option value="country" style={{ backgroundColor: "#ffff" }}>Country</Option>
                            <Option value="operating_system" style={{ backgroundColor: "#ffff" }}>Operating System</Option>
                        </Select>
                    }
                    dataIndex="field"
                    key="field"
                    render={(text) => <span>{text ?? "None"}</span>}
                    align="left"
                />

                <Column
                    title="Views"
                    dataIndex="views"
                    key="views"
                    align="center"
                    render={(views) => (views ? views : 0)}
                />

                <Column
                    title="Playing Time"
                    dataIndex="total_playing_time"
                    key="total_playing_time"
                    align="right"
                    render={(playing_time) => (playing_time ? calculatePlayingTime(playing_time) : 0)}
                />
            </Table>
        </div>
    );
};
